import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import BaseFormContainer from '../../common/components/form/BaseFormContainer';
import { BlockingLoader } from '../../common/components/loader';

import * as contentActions from '../../content/content.actions';
import * as prizeActions from '../prize.actions';
import PrizeForm from './PrizeForm';
import { Localize } from '../../../locale/localization';

const constraints = {
  name: {
    presence: {
      message: `^${Localize('form.prize.name.error')}`
    },
  },
  type: {
    presence: {
      message: `^${Localize('form.prize.type.error')}`
    },
  },
  price: {
    numericality: {
      onlyInteger: true,
      message: `^${Localize('form.prize.price.error')}`
    },
    presence: {
      message: `^${Localize('form.prize.price.error')}`
    },
  },
  description: {
    presence: {
      message: `^${Localize('form.prize.description.error')}`
    },
  }
  // vendorUrl: {
  //   url: {
  //     message: `^${Localize('form.prize.vendor-url.error')}`
  //   },
  // },
};

class PrizeFormContainer extends BaseFormContainer {
  constructor(props) {
    super(props);

    const formData = {
      name: '',
      type: '',
      price: '',
      description: '',
      image: '',
      vendorUrl: '',
    };

    this.state = {
      ...this.state,
      isUploading: false,
      formData,
    };
  }

  componentWillMount = () => {
    const {
      id,
      getPrize,
    } = this.props;

    if(id) {
      getPrize(id).then(() => {
        const { prize } = this.props;
        const {
          name = '',
          type = '',
          price = '',
          description = '',
          image = '',
          vendorUrl = ''
        } = prize;

        const { formData } = this.state;

        this.setState({
          formData: {
            ...formData,
            name,
            type,
            price,
            description,
            image,
            vendorUrl,
          }
        }, this.validate);
      });
    }
  }

  getConstraints = () => constraints;

  doSubmit = (formData) => {
    const { updatePrize, createPrize, cancelPath, history } = this.props;
    if(this.props.id) {
      updatePrize({
        _id: this.props.id,
        ...formData,
      }).then(() => {
        history.replace(cancelPath);
      });
    } else {
      createPrize(formData).then(() => {
        history.replace(cancelPath);
      });
    }
  }

  onCancel = (event) => {
    event.preventDefault();
    
    const { cancelPath, history } = this.props;
    history.replace(cancelPath);
  }

  //TODO
  onFileInputChange = (event) => {
    this.setState({
      isUploading: true,
      formError: '',
    }, this.forceUpdate);
    const { uploadImage } = this.props;
    const target = event.target;
    const uploadFormData = new FormData();
    uploadFormData.append('file', target.files[0]);
    const { formData } = this.state;
    uploadImage(uploadFormData).then((action) => {
      this.setState({
        formData: {
          ...formData,
          image: action.response.url,
        },
        isUploading: false,
        formError: '',
      }, this.forceUpdate);
    }).catch((error) => {
      this.setState({
        isUploading: false,
        formError: `${Localize('form.prize.image.error')}`
      }, this.forceUpdate);
    });
  }

  render() {    
    return (
      <div>
        <PrizeForm
          enabled={!this.state.isSubmitting && !this.state.isUploading}
          onSubmit={this.onSubmit}
          onCancel={this.onCancel}
          onInputChange={this.onInputChange}
          onBlur={this.onBlur}
          onFileInputChange={this.onFileInputChange}
          errors={this.state.errors}
          touchedFields={this.state.touchedFields}
          isValid={this.state.isValid}
          name={this.state.formData.name}
          type={this.state.formData.type}
          price={this.state.formData.price}
          description={this.state.formData.description}
          image={this.state.formData.image}
          vendorUrl={this.state.formData.vendorUrl}
          formError={this.state.formError}
        />
        <BlockingLoader isLoading={this.state.isUploading} />
      </div>
    );
  }
}

const mapStateToProps = (state, { match, cancelPath }) => {
  const {
    id
  } = match.params;

  const prize = state.entities.prize.byId[id];
  //TODO
  return {
    id,
    prize,
    cancelPath,
  };
};

const ConnectedPrizeFormContainer = connect(
  mapStateToProps,
  Object.assign({}, prizeActions, contentActions),
)(PrizeFormContainer);

export default withRouter(ConnectedPrizeFormContainer);


// WEBPACK FOOTER //
// ./src/modules/prize/components/PrizeFormContainer.js